import { render, staticRenderFns } from "./DashboardWidgetView.vue?vue&type=template&id=3dfcb21c&"
import script from "./DashboardWidgetView.vue?vue&type=script&lang=ts&"
export * from "./DashboardWidgetView.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardWidgetView.vue?vue&type=style&index=0&id=3dfcb21c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports